module.exports = __webpack_public_path__ + "img/45.people_counter.6ae845e2.svg";